import { Phone, Mail, MapPin, Clock, Shield } from "lucide-react";

const PHONE_NUMBER = "306-262-5995";
const EMAIL = "306LOCKSMITH@GMAIL.COM";
const LOGO_URL = "https://customer-assets.emergentagent.com/job_emergency-locksmith-4/artifacts/dcw292bm_ChatGPT%20Image%20Mar%2027%2C%202026%2C%2010_11_56%20PM.png";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const services = [
    "Residential Locksmith",
    "Commercial Locksmith",
    "Automotive Locksmith",
    "Emergency Lockouts",
    "Lock Rekeying",
    "Key Cutting",
  ];

  const serviceAreas = [
    "Saskatoon",
    "Warman",
    "Martensville",
    "Osler",
    "Dalmeny",
    "Dundurn",
  ];

  return (
    <footer className="footer-gradient text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Company Info */}
          <div>
            <img
              src={LOGO_URL}
              alt="306 Locksmith"
              className="h-16 w-auto mb-4"
            />
            <p className="text-slate-400 mb-6">
              Your trusted local locksmith serving Saskatoon and surrounding areas. Available 24/7 for all your lock and key needs.
            </p>
            <div className="flex items-center gap-2 text-amber-400">
              <Shield className="w-5 h-5" />
              <span className="text-sm font-semibold">Licensed & Insured</span>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-heading text-lg mb-4">Services</h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service}>
                  <a
                    href="#services"
                    className="text-slate-400 hover:text-amber-400 transition-colors text-sm"
                  >
                    {service}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Service Areas */}
          <div>
            <h4 className="font-heading text-lg mb-4">Service Areas</h4>
            <ul className="space-y-2">
              {serviceAreas.map((area) => (
                <li key={area} className="text-slate-400 text-sm flex items-center gap-2">
                  <MapPin className="w-3 h-3 text-amber-400" />
                  {area}
                </li>
              ))}
              <li className="text-slate-500 text-sm mt-2">
                + All surrounding communities
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg mb-4">Contact Us</h4>
            <ul className="space-y-4">
              <li>
                <a
                  href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}
                  className="flex items-center gap-3 text-amber-400 hover:text-amber-300 transition-colors"
                  data-testid="footer-phone"
                >
                  <Phone className="w-5 h-5" />
                  <span className="font-semibold">{PHONE_NUMBER}</span>
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${EMAIL}`}
                  className="flex items-center gap-3 text-slate-400 hover:text-amber-400 transition-colors text-sm"
                  data-testid="footer-email"
                >
                  <Mail className="w-5 h-5" />
                  <span>{EMAIL}</span>
                </a>
              </li>
              <li className="flex items-center gap-3 text-slate-400 text-sm">
                <Clock className="w-5 h-5" />
                <span>24 Hours / 7 Days</span>
              </li>
            </ul>

            {/* Emergency Banner */}
            <div className="mt-6 p-4 bg-amber-500/20 border border-amber-500/50 rounded-sm">
              <p className="text-amber-400 text-sm font-semibold">
                Locked Out? Call Now!
              </p>
              <a
                href={`tel:${PHONE_NUMBER.replace(/-/g, "")}`}
                className="text-white font-heading text-xl"
              >
                {PHONE_NUMBER}
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} 306 Locksmith. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <a href="#services" className="text-slate-500 hover:text-white text-sm transition-colors">
              Services
            </a>
            <a href="#about" className="text-slate-500 hover:text-white text-sm transition-colors">
              About
            </a>
            <a href="#contact" className="text-slate-500 hover:text-white text-sm transition-colors">
              Contact
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
